import {
    Button,
    ButtonProps,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalWindow,
} from '@cxc/react-fpds-components';
import ModalProps from '../../types/props/ModalProps';

const Modal = ({
    title,
    description,
    buttons,
    buttonPlacement,
    isOpen,
    setIsOpen,
    headingLevel,
    variant,
    url,
}: ModalProps) => {
    const handleCloseModal = () => {
        setIsOpen(false);
    };

    const handleContinue = () => {
        setIsOpen(false);
        window.open(url, '_blank');
    };

    const handleButtonClick = (id: string) => {
        if (id === 'continue') {
            handleContinue();
        } else {
            handleCloseModal();
        }
    };

    return (
        <ModalWindow variant={variant} isOpen={isOpen} onClose={handleCloseModal}>
            <ModalHeader headingLevel={headingLevel} onClose={handleCloseModal}>
                {title}
            </ModalHeader>
            <ModalBody>{description}</ModalBody>
            <ModalFooter placement={buttonPlacement}>
                {buttons.map((button: ButtonProps) => (
                    <Button
                        dataTestId={`button-${button.id}`}
                        style={{ marginRight: '20px' }}
                        key={button.id}
                        size={button.size}
                        buttonColor={button.buttonColor}
                        buttonType={button.buttonType}
                        as={button.as}
                        onClick={() => handleButtonClick(button.id || '')}
                    >
                        {button.name}
                    </Button>
                ))}
            </ModalFooter>
        </ModalWindow>
    );
};

export default Modal;
